import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';
import { toNumber } from 'lodash';

@Component({
  selector: 'app-field-number',
  templateUrl: './field-number.component.html',
  styleUrl: './field-number.component.scss'
})
export class FieldNumberComponent {
  private _classSet: Set<string> = new Set<string>();

  @Output() valueChange = new EventEmitter<number>;
  @Input() placeholder?: string;
  @Input() value?: string | number;
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onChange(event: AnyObject){
    this.valueChange.emit(toNumber(event.target.value))
  }

  onFocus(){
    this._classSet.add('card-focus');
  }

  onBlur(){
    this._classSet.delete('card-focus');
  }
}
